import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

export function useImpersonate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (userId: string) =>
      api.post<{
        impersonating: { id: string; email: string; full_name: string | null };
        audit_id: string;
      }>(`/api/platform/users/${userId}/impersonate`, {}),
    onSuccess: () => {
      // We're a different user now — wipe cached queries so the next
      // /me, sites, packages, etc. all re-fetch under the new session.
      qc.clear();
    },
  });
}

export function useReturnToAdmin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.post<{ returned: boolean }>('/api/auth/impersonate/return', {}),
    onSuccess: () => {
      qc.clear();
    },
  });
}
